import { createI18n } from 'vue-i18n'

// singleton
window.loadedLocales = []
const messages = {}
let i18n = createI18n({
  messages,
  silentFallbackWarn: true,
  warnHtmlMessage: false,
  fallbackLocale: 'ja',
  missing: (locale, key) => {
    if (import.meta.env.VITE_NODE_ENV === 'development') {
      console.warn(`[i18n] Key '${key}' not found in '${locale}' locale!`)
    }
  }
})

export default i18n
